/** 从 XP 低版本提示点击「去浏览器打开」时携带，用于忽略原生再次附加的 os=xp */
export const XP_OPEN_BROWSER_PARAM = 'openBrowser'

function queryValue(value: unknown): string | undefined {
  if (Array.isArray(value)) return value[0]
  if (value == null || value === '') return undefined
  return String(value)
}

export function isXpLowVersion(query: Record<string, unknown>): boolean {
  const openBrowser = queryValue(query[XP_OPEN_BROWSER_PARAM])
  if (openBrowser === '1' || openBrowser === 'true') {
    return false
  }
  return queryValue(query.os) === 'xp'
}

export function appendOpenBrowserToUrl(url: string): string {
  const param = `${XP_OPEN_BROWSER_PARAM}=1`
  if (new RegExp(`${XP_OPEN_BROWSER_PARAM}=`).test(url)) {
    return url.replace(new RegExp(`${XP_OPEN_BROWSER_PARAM}=[^&#]*`), param)
  }
  const hashIdx = url.indexOf('#')
  if (hashIdx === -1) {
    return url + (url.includes('?') ? '&' : '?') + param
  }
  const before = url.slice(0, hashIdx)
  const hash = url.slice(hashIdx)
  if (hash.includes('?')) {
    return before + hash + '&' + param
  }
  return before + hash + '?' + param
}
